import { render, staticRenderFns } from "./BossApp.vue?vue&type=template&id=201cc2cf&scoped=true&"
import script from "./BossApp.vue?vue&type=script&lang=js&"
export * from "./BossApp.vue?vue&type=script&lang=js&"
import style0 from "./BossApp.vue?vue&type=style&index=0&id=201cc2cf&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "201cc2cf",
  null
  
)

export default component.exports